// Libraries
import React from 'react';

// Supermove
import {Icon, Popover} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {useModal, usePopover, useToast} from '@supermove/hooks';
import {ClaimModel} from '@supermove/models';
import {colors} from '@supermove/styles';

// Shared
import ActionMenuPopover from '@shared/design/components/ActionMenu/ActionMenuPopover';
import TertiaryButton from '@shared/design/components/Button/TertiaryButton';
import SuccessToast from '@shared/design/components/Toast/SuccessToast';
import RemoveClaimModal from '@shared/modules/Claim/components/RemoveClaimModal';

const ClaimActionsButton = ({claim, refetch}: {claim: ClaimModel; refetch: () => void}) => {
  const claimActionsPopover = usePopover();
  const removeClaimModal = useModal({name: 'Remove Claim Modal'});
  const removeClaimSuccessToast = useToast({
    ToastComponent: SuccessToast,
    message: `Claim ${claim.identifier} removed`,
  });
  return (
    <React.Fragment>
      <ActionMenuPopover
        popover={claimActionsPopover}
        placement={Popover.Positions.Bottom}
        width={160}
        offset={[-144, 4]}
        actions={[
          {
            label: 'Delete claim',
            onPress: removeClaimModal.handleOpen,
          },
        ]}
      >
        <TertiaryButton
          style={{paddingLeft: 8, paddingRight: 8}}
          onPress={claimActionsPopover.handleToggle}
        >
          <Icon source={Icon.EllipsisV} size={16} color={colors.gray.secondary} />
        </TertiaryButton>
      </ActionMenuPopover>
      <RemoveClaimModal
        key={claim.id}
        claimId={claim.id}
        isOpen={removeClaimModal.isOpen}
        handleClose={removeClaimModal.handleClose}
        onSuccess={() => {
          removeClaimSuccessToast.handleToast();
          refetch();
        }}
      />
    </React.Fragment>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
ClaimActionsButton.fragment = gql`
  fragment ClaimActionsButton on Claim {
    id
    identifier
  }
`;

export default ClaimActionsButton;
